import React from 'react'
import { useTheme, useThemeTokens, type ThemeName } from '../themes'
import { Dropdown, type DropdownOption } from './ui/Dropdown.js'

export const ThemeSwitcher: React.FC = () => {
  const { themeName, setTheme, availableThemes } = useTheme()
  const theme = useThemeTokens()
  
  // Convert theme names to dropdown options
  const themeOptions: DropdownOption[] = availableThemes.map(themeKey => ({
    id: themeKey,
    label: themeKey.charAt(0).toUpperCase() + themeKey.slice(1),
    value: themeKey,
    icon: getThemeIcon(themeKey)
  }))

  function getThemeIcon(theme: string): string {
    switch (theme) {
      case 'base': return '🎨'
      case 'minimal': return '🔲'
      case 'corporate': return '🏢'
      case 'dark': return '🌙'
      case 'light': return '☀️'
      default: return '🎨'
    }
  }
  
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    padding: theme.spacing.sm,
    backgroundColor: theme.colors.surface,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.md,
    boxShadow: theme.shadows.sm,
  }
  
  const labelStyles: React.CSSProperties = {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    color: theme.colors.text,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    whiteSpace: 'nowrap'
  }

  const handleThemeSelect = (option: DropdownOption) => {
    const themeName = option.value as ThemeName
    setTheme(themeName)
  }
  
  return (
    <div style={containerStyles}>
      <label style={labelStyles}>Theme:</label>
      <div style={{ minWidth: '140px' }}>
        <Dropdown
          options={themeOptions}
          value={themeName}
          onSelect={handleThemeSelect}
          placeholder="Select theme..."
        />
      </div>
    </div>
  )
} 